import { createFileRoute } from '@tanstack/react-router';
import { CategoryAuditPage } from './CategoryAuditPage';
import { z } from 'zod';

const searchSchema = z.object({
  merchantName: z.string().optional(),
  lineItemDescription: z.string().optional(),
  lineItemCategory: z.string().optional(),
  createdAfter: z.coerce.date().optional(),
  createdBefore: z.coerce.date().optional(),
  updatedAfter: z.coerce.date().optional(),
  updatedBefore: z.coerce.date().optional(),
  updateState: z.enum(['never_updated', 'updated', 'either']).optional().default('either'),
  sortBy: z
    .enum(['merchant_name', 'line_item_category', 'created_at', 'updated_at'])
    .optional()
    .default('updated_at'),
  sortOrder: z.enum(['asc', 'desc']).optional().default('desc'),
  page: z.coerce.number().positive().int().optional().default(1),
  pageSize: z.coerce.number().positive().int().optional().default(25),
});

export const Route = createFileRoute('/_protected/admin/internal-tools/category-audit/')({
  component: CategoryAuditPage,
  validateSearch: searchSchema,
});
